// How small a code can be printed and still scan. Shared by the generator
// widgets (the size line under the preview) and the size calculator.
//
// A phone has to tell one module from the next, so the limit is the width of a
// module on paper, not the width of the code. The more data a code holds, the
// more modules it has, and the larger it must be printed.
//
// MIN_MODULE_MM is the floor for a phone held close. It rounds up GS1's
// minimum module width for a consumer-facing QR code (0.396 mm), and it is
// what this site's own 10:1 rule gives for a short link scanned at about
// 12 cm, which is as close as most phone cameras focus.
export const MIN_MODULE_MM = 0.4

// The empty border the QR spec requires on each side. Every download from the
// tool widgets includes it (see toSvg / toPngDataUrl in qr-core), so a print
// size always means the width of the whole image.
export const QUIET_ZONE_MODULES = 4

const MM_PER_INCH = 25.4

// Modules across the printed image: the pattern plus the quiet zone twice.
export function printModules(moduleCount) {
  return moduleCount + QUIET_ZONE_MODULES * 2
}

// The smallest width, in mm, to print a code with this many modules a side.
export function minPrintMm(moduleCount) {
  return printModules(moduleCount) * MIN_MODULE_MM
}

// Rounds up to one decimal place. A code that runs a little large always
// scans, and one that runs a little small sometimes does not. The epsilon
// keeps float noise (32.400000000000006) from adding a tenth.
export function ceil1(n) {
  return Math.ceil(n * 10 - 1e-9) / 10
}

// "1.3 in (3.3 cm)"
export function formatPrintSize(mm) {
  return `${ceil1(mm / MM_PER_INCH)} in (${ceil1(mm / 10)} cm)`
}
